import 'css-chunk:src/app/containers/Application/ApplicationContainer.scss';export default {
  "ApplicationContainer": "_ApplicationContainer_1vgsr_1",
  "modalView": "_modalView_1vgsr_7"
};